import { render, staticRenderFns } from "./SuccessfullySavedAlert.vue?vue&type=template&id=45248350&"
import script from "./SuccessfullySavedAlert.vue?vue&type=script&lang=js&"
export * from "./SuccessfullySavedAlert.vue?vue&type=script&lang=js&"
import style0 from "./SuccessfullySavedAlert.vue?vue&type=style&index=0&id=45248350&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports